import * as types from "../constants/actionTypes";
import initialState from "./initialState";

export default (state = initialState.isGlobalFetch, action) => {
  switch (action.type) {
    case types.DEAL_ANIMATION_START:
      return true;

    case types.DEAL_ANIMATION_END:
      return false;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/isDealAnimationActive.js